export function Ratio16x9Icon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect x="18.75" y="5" width="10" height="17.5" rx="2" transform="rotate(90 18.75 5)" stroke="currentColor" stroke-width="1.6625" />
    </svg>
  );
}

Ratio16x9Icon.displayName = 'Ratio16x9Icon';
